import './tableData.scss';

import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Wrapper = forwardRef((props, ref) => {
  const className = classNames({
    'table-data': true,
    [`table-data-${props.type}`]: props.type,
    [`table-data-${props.appearance}`]: props.appearance,
    [props.className]: props.className,
  });

  return (
    <div className={className} ref={ref}>
      {props.children}
    </div>
  );
});

Wrapper.propTypes = {
  type: PropTypes.string,
  appearance: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
};

Wrapper.defaultProps = {
  type: 'cart',
  appearance: 'compact',
};

const Row = forwardRef((props, ref) => {
  const className = classNames({
    'table-data-row': true,
    [`table-data-row-${props.type}`]: props.type,
    [props.className]: props.className,
  });

  return (
    <div ref={ref} className={className}>
      {props.children}
    </div>
  );
});

Row.propTypes = {
  type: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
};

Row.defaultProps = {};

const Col = forwardRef((props, ref) => {
  const className = classNames({
    'table-data-cell': true,
    [`table-data-cell-${props.type}`]: props.type,
    [props.className]: props.className,
  });

  return (
    <div ref={ref} className={className}>
      {props.children}
    </div>
  );
});

Col.propTypes = {
  type: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
};

Col.defaultProps = {};

const TableData = { Wrapper, Row, Col };

export default TableData;
